// Minimal RFC-4180-ish CSV parser (handles quotes, commas, newlines in quotes). Also accepts tab-separated text.
export function parseCsv(text) {
  const rows = [];
  let row = [], field = '', inQuotes = false;
  const src = text.replace(/\r\n?/g, '\n');
  const delim = src.split('\n')[0]?.includes('\t') && !src.split('\n')[0]?.includes(',') ? '\t' : ',';
  for (let i = 0; i < src.length; i++) {
    const ch = src[i];
    if (inQuotes) {
      if (ch === '"') {
        if (src[i + 1] === '"') { field += '"'; i++; } else inQuotes = false;
      } else field += ch;
    } else if (ch === '"') inQuotes = true;
    else if (ch === delim) { row.push(field); field = ''; }
    else if (ch === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
    else field += ch;
  }
  if (field !== '' || row.length) { row.push(field); rows.push(row); }
  return rows.map((r) => r.map((c) => c.trim())).filter((r) => r.some(Boolean));
}

const HEADER_ALIASES = {
  unit_id: ['asset_id', 'asset id', 'asset', 'asset #', 'unit_id', 'unit', 'unitid', 'unit id', 'unit #', 'unit no', 'tag', 'equipment tag'],
  lsd: ['lsd', 'address', 'lsd/address', 'lsd / address', 'legal', 'location lsd'],
  location: ['location', 'site', 'site name', 'sitename', 'facility', 'battery'],
  equipment_type: ['equipment_type', 'type', 'equipment type', 'equipment'],
  style: ['style', 'pump style', 'pump_style'],
  make: ['make', 'manufacturer', 'mfr', 'mfg', 'brand', 'oem'],
  model: ['model', 'model #', 'model no', 'model number'],
  serial_number: ['serial_number', 'serial', 'serial #', 'serial no', 'sn', 's/n', 'serial number'],
  product_pumped: ['product_pumped', 'product', 'product pumped', 'fluid', 'service'],
  notes: ['notes', 'note', 'comments', 'description'],
};

const DEFAULT_ORDER = ['unit_id', 'location', 'lsd', 'equipment_type', 'style', 'make', 'model', 'serial_number', 'product_pumped', 'notes'];

// Returns { fields: [field|null per column], hasHeader }.
export function detectColumns(firstRow) {
  const fields = firstRow.map((h) => {
    const key = h.toLowerCase().trim();
    return Object.keys(HEADER_ALIASES).find((f) => HEADER_ALIASES[f].includes(key)) || null;
  });
  const hasHeader = fields.filter(Boolean).length >= 2;
  return hasHeader ? { fields, hasHeader } : { fields: DEFAULT_ORDER.slice(0, firstRow.length), hasHeader: false };
}

export function rowsToUnits(rows) {
  if (!rows.length) return { units: [], hasHeader: false, fields: [] };
  const { fields, hasHeader } = detectColumns(rows[0]);
  const body = hasHeader ? rows.slice(1) : rows;
  const units = body.map((r) => {
    const u = {};
    fields.forEach((f, i) => { if (f && r[i]) u[f] = r[i]; });
    return u;
  }).filter((u) => Object.keys(u).length);
  return { units, hasHeader, fields };
}
